module.exports = __webpack_public_path__ + "static/media/wide.e2d0d4ef.jpg";